import moment from "moment";
import React, { useState } from "react";
import CustomToast from "../../../cross/CustomToast";
import ICurrentUser from "../../../entities/helper/ICurrentUser";
import IPrograma from "../../../entities/IPrograma";
import { postAPI } from "../../../helpers/httpHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../../helpers/userHelper";
import { API_AUDITORIA, API_AUDITORIA_POST_PROGRAMASAUDITORIAS } from "../../../helpers/variableHelper";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);

export default function AgregarPrograma() {
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [isLoading, setIsLoading] = useState(true);
  const [isSendingData, setIsSendingData] = useState(false);

  const refTxtNombrePrograma = React.createRef<HTMLInputElement>();
  const refTxtAnioAuditoria = React.createRef<HTMLInputElement>();
  const refTxtFechaAprobacionAuditoria = React.createRef<HTMLInputElement>();
  const [contadorCharNombrePrograma, setContadorCharNombrePrograma] = useState(0);
  const [showToast, setShowToast] = useState(false);
  const [arrErrorEmpty, setArrErrorEmpty] = useState<Array<string>>([]);
  console.log(isLoading);
  usePromiseEffect(async () => {
    let token = await userInfo;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);
    setIsLoading(false);
  }, []);

  const formValidation = (value: Partial<IPrograma>) => {
    let arrErrors: Array<string> = [];
    if (!value.NOMBRE) {
      arrErrors.push("NOMBRE");
    }
    if (!value.ANIO) {
      arrErrors.push("ANIO");
    } else if (value.ANIO < moment().year()) {
      MySwal.fire({
        html: (
          <div>
            <h3>El campo año no puede ser menor al año actual {moment().year()}</h3>
          </div>
        ),
        text: "",
        icon: "error",
        showCloseButton: true,
      });
      (refTxtAnioAuditoria.current as HTMLInputElement).value = moment().year().toString();
      arrErrors.push("ANIO");
    }

    if (!moment(value.FECHA_APROBACION).isValid()) {
      arrErrors.push("FECHA_APROBACION");
    }
    setArrErrorEmpty(arrErrors);
    return arrErrors.length === 0;
  };

  const handleGuardar = () => {
    let item = {
      NOMBRE: refTxtNombrePrograma.current?.value,
      ANIO: parseInt(refTxtAnioAuditoria.current?.value as string),
      FECHA_APROBACION: moment(refTxtFechaAprobacionAuditoria.current?.value as string).toDate(),
      FECHA_CREACION: moment().toDate(),
      AUTOR: currentUser?.email,
      AUTOR_DISPLAY: currentUser?.fullname,
    };
    let validation = formValidation(item);
    if (validation) {
      setIsSendingData(true);
      postAPI(`${API_AUDITORIA}${API_AUDITORIA_POST_PROGRAMASAUDITORIAS}`, item, {
        Authorization: `Bearer ${token}`,
      })
        .then((result) => {
          let data = result.result.data;
          setShowToast(true);
          window.location.href = `detalleprograma?id=${data.data}`;
        })
        .catch((error) => {
          console.log(error);
          setIsSendingData(false);
        });
    }
  };
  return (
    <div className="row">
      <div className="col-12">
        <div className="rounded bg-white p-2 shadow">
          <div className="container-fluid mb-4">
            <h1 className="titPrincipal colorTit">Auditoría</h1>

            <div className="card bg-light border p-3 pt-2 mt-2">
              <div className="row ajusteInput">
                <div className="col-12">
                  <h6>
                    <span className="textSeccion">Antecedentes</span>
                  </h6>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                  <label>
                    <span className="text-danger">(*)</span> Nombre Programa
                  </label>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                  <input
                    ref={refTxtNombrePrograma}
                    className={`${arrErrorEmpty.includes("NOMBRE") && "error"} form-control form-control-sm w-50`}
                    type="text"
                    onChange={() => {
                      setContadorCharNombrePrograma(refTxtNombrePrograma.current?.value.length || 0);
                    }}
                    maxLength={250}
                  />
                  <span>
                    <small>{contadorCharNombrePrograma}/250</small>
                  </span>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                  <label>
                    <span className="text-danger">(*)</span> Año Auditoría
                  </label>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                  <input
                    ref={refTxtAnioAuditoria}
                    type="number"
                    min={moment().year()}
                    className={`${arrErrorEmpty.includes("ANIO") && "error"} form-control form-control-sm w-50`}
                    onBlur={(e) => {
                      if (parseInt(e.target.value) < moment().year()) {
                        (refTxtAnioAuditoria.current as HTMLInputElement).value = moment().year().toString();
                      }

                      if (moment(refTxtFechaAprobacionAuditoria.current?.value).year() != parseInt(e.target.value)) {
                        (refTxtFechaAprobacionAuditoria.current as HTMLInputElement).value = moment(refTxtFechaAprobacionAuditoria.current?.value)
                          .year(parseInt(e.target.value))
                          .format("yyyy-MM-DD");
                      }
                    }}
                  />
                </div>
                <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                  <label>
                    <span className="text-danger">(*)</span> Fecha Aprobación Auditoría
                  </label>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                  <input
                    ref={refTxtFechaAprobacionAuditoria}
                    className={`${arrErrorEmpty.includes("FECHA_APROBACION") && "error"} form-control form-control-sm w-50`}
                    type="date"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
                  <button type="button" className="btn btn-sm btn-primary me-2" onClick={handleGuardar} disabled={isSendingData}>
                    {" "}
                    Grabar
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => (window.location.href = "/auditoria/home")}
                    disabled={isSendingData}>
                    Volver
                  </button>
                </div>
              </div>
              <CustomToast show={showToast} title={"Auditoría"} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
